// extracted by mini-css-extract-plugin
export var buttonContainer = "_9e-1";
export var fontSizeSelect = "_9e-3";
export var formatSelect = "_9e-2";
export var formats = "_9e-4";
export var hidden = "_9e-5";
export var icon = "_9e-6";
export var select = "_9e-0";